import { humanize, moment } from 'utils';

import BasePropertyObject from './BasePropertyObject';

export default class BaseTransportObject extends BasePropertyObject {
  constructor({
    vin,
    type,
    useTerm,
    sntsType,
    isStolen,
    category,
    horsepower,
    returnDate,
    manufactureYear,
    searchStartDate,
    registrationSign,
    ...basePropertyObjectConfig
  }) {
    super(basePropertyObjectConfig);

    Object.assign(this, {
      vin,
      type,
      useTerm,
      sntsType,
      isStolen,
      category,
      horsepower,
      manufactureYear,
      registrationSign,
      returnDate: returnDate && moment.fromServerDatetime(returnDate),
      searchStartDate: searchStartDate && moment.fromServerDatetime(searchStartDate),
    });

    Object.assign(this.propertyTitles, {
      vin: 'VIN',
      type: 'Тип ТС',
      category: 'Категория ТС',
      registrationSign: 'Рег. номер',
      manufactureYear: 'Год выпуска',
      isStolen: 'Сведения об угоне',
      searchStartDate: 'Дата начала розыска',
      returnDate: 'Дата возврата',
      registrationDate: 'Дата постановки на учет',
      registrationEndDate: 'Дата снятия с учета',
    });

    Object.assign(this.propertyDisplayValueGetters, {
      isStolen: () =>
        this.searchStartDate && !this.returnDate
          ? 'В розыске'
          : this.searchStartDate && this.returnDate
          ? 'Не в розыске'
          : null,
      returnDate: () => this.returnDate && this.returnDate.defaultFormat(),
      searchStartDate: () => this.searchStartDate && this.searchStartDate.defaultFormat(),
      type: () => this.sntsType,
      horsepower: () => humanize(this.horsepower),
    });
  }

  static typeTitle = 'Транспорт';

  getTypeTitle() {
    return BaseTransportObject.typeTitle;
  }

  isTransport() {
    return true;
  }

  getDataProvider() {
    return null;
  }

  getCategoryTitle() {
    return this.title || this.sntsType || '';
  }
}
